import { useEffect, useState } from 'react';

import { apiPaths } from '../../../../../service/apiPaths';
import ApiService from '../../../../../service/ApiService';

interface IProjectView {
  _id: string;
  name: string;
  description: string;
  status: string;
  totalHours: number;
  users: Array<{
    name: string;
    email: string;
    role: string;
    totalHours: number;
    dateWise: Array<{
      date: string;
      hours: number;
    }>;
  }>;
}

const useViewProject = (leaveId: IProjectView) => {
  const [leaveData, setProjectData] = useState<IProjectView | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchProjectData = async () => {
      if (!leaveId?._id) return;

      setLoading(true);
      try {
        const result = await ApiService({
          method: "GET",
          endpoint: `${apiPaths.getProjectById}/${leaveId._id}`,
        });
        setProjectData(result.data);
      } catch (error) {
        console.error("Error fetching leave data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjectData();
  }, [leaveId?._id]);

  return {
    leaveData,
    loading,
  };
};

export default useViewProject;
